<!--footer section -->
<footer class="footer-light sticky mt-2 " >
<div class="d-flex flex-row justify-content-between align-items-end ml-4 mr-4"  >
  <div class="d-flex flex-column align-items-center"
   [class.selected]="selectedIcon === 'home'" (click)="changeIconColor('', 'home')">
    <i class="fa fa-home fa-2x cursor-pointer"  [class.selected]="selectedIcon === 'home'" ></i>
    <span class="cursor-pointer" [class.selected]="selectedIcon === 'home'" >Home</span>
  </div>
  <div class="d-flex flex-column align-items-center"
   *ngIf="!isSearchDisable"
   [class.selected]="selectedIcon === 'search'" (click)="changeIconColor('/shop/machines', 'search')"
   >
    <i class="fa fa-search fa-2x cursor-pointer"  [class.selected]="selectedIcon === 'search'" (click)="changeIconColor('/shop/machines', 'search')"></i>   
     <span class="cursor-pointer" [class.selected]="selectedIcon === 'search'">Search</span>
  </div>
  <div class="d-flex flex-column align-items-center text-white" (click)="OnCartClick(cartItemPopup)">
    <div class="circle"   >
      <i class="fa fa-shopping-cart fa-2x cursor-pointer" *ngIf="cartCount!=0" [matBadge]="cartCount" matBadgePosition="before" matBadgeColor="accent"></i>
      <i class="fa fa-shopping-cart fa-2x cursor-pointer" *ngIf="cartCount==0" ></i>
      <span class="text-white cursor-pointer">Cart</span>
    </div>
  </div>
  <div class="d-flex flex-column align-items-center"
  [class.selected]="selectedIcon === 'myorders'" (click)="changeIconColor('/pages/my-orders', 'myorders')">
   <i class="fa fa-sticky-note fa-2x cursor-pointer" [class.selected]="selectedIcon === 'myorders'" ></i>

   <span class="cursor-pointer">My Orders</span>
 </div>
 <div class="d-flex flex-column align-items-center"
 [class.selected]="selectedIcon === 'info'" (click)="changeIconColor('/pages/aboutus','info')">
  <i class="fa fa-info fa-2x cursor-pointer" [class.selected]="selectedIcon === 'info'" ></i>

  <span class="cursor-pointer">About</span>
</div>

  <!-- <div class="d-flex flex-column align-items-center"
   [class.selected]="selectedIcon === 'payments'"  (click)="changeIconColor('payments')">
    <i class="fa fa-credit-card fa-2x cursor-pointer" [class.selected]="selectedIcon === 'payments'"></i>
    <span class="cursor-pointer">Payments</span>
  </div> -->

</div>
</footer>
<ng-template #cartItemPopup>
  <div class="modal-header">
    <h5 class="modal-title f-w-600" id="exampleModalLabel">Check Items</h5>
    <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="modalReference.close()"
    >
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body overflow-auto" style="height: 75vh !important;">
  <div
  class="d-flex flex-column"
  
  style="height: 100% !important"
>
  <div
    class="heading d-flex justify-content-between align-items-center pl-1"
    *ngIf="cartItems?.length > 0"
    style="
      width: 100% !important;
      height: 40px !important;
      background: orangered;
      padding-right: 12px;
      gap: 10px;
    "
  >
    <div class="d-flex">
      <span class="font-size-24 font-weight-bold" style="color: white"
        >Total Items:
        {{
          cartObj.totalCount
        }}</span
      >
    </div>
    <div>
      <span class="font-size-24 font-weight-bold" style="color: white"
        >Total Price:
        {{
          cartObj.totalPrice
            | currency: "INR":"symbol":"1.0-2"
        }}
      </span>
    </div>
  </div>
  <div
    class="cart-items"
    style="height: 100% !important; overflow: auto !important"
   
  >
    <div
      class="full-data"
      *ngFor="let cartproducts of cartItems"
     
    >
    
      <div class="d-flex flex-row justify-content-between" >
        <div class="img">
          <img [src]="itemImgLoc + cartproducts?.prodImage" class="prod-img">
          <!-- <div class="sold-out">Sold Out</div> -->
        </div>
        <div
          class="d-flex flex-column pl-1"
          style="width: 40% !important"
        >
       
          <div
            class="semi-bold"
            ngbTooltip="{{ cartproducts?.prodName }}"
          >
            <!-- {{ cartItem?.prodName }} -->
            {{
              cartproducts?.prodName.length > 15
                ? (cartproducts?.prodName | slice: 0:10) + "..."
                : cartproducts?.prodName
            }}
          </div>
          <div class="qty-price pr-2">
            {{
              cartproducts.offerPrice | currency: "INR":"symbol":"2.0-2"
            }}
          </div>
        </div>
        <div class="d-flex align-items-center" style="gap: 6px">
          <span >
            <i
            class="fa fa-minus fa-1x"
            style="color: rgba(0, 128, 0, 0.699)"
            (click)="decrementCartItem(cartproducts)"
          ></i>

          </span>
         
          <span class="mx-1">{{
           cartproducts.itemCount
          }}</span>
        <span >
          <i
          class="fa fa-plus fa-1x"
          style="color: rgba(0, 128, 0, 0.699)"
          (click)="incrementCartItem(cartproducts)"
        ></i>

        </span>
         
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <span class="price-style pr-2">{{
            cartproducts.totalPrice
              | currency: "INR":"symbol":"1.0-2"
          }}</span>
        </div>
        <div
        class="last-div d-flex justify-content-center align-items-center pr-1"
      >
        <i
          class="ti-trash"
          (click)="deleteCartItem(cartproducts)"
        ></i>
      </div>
      </div>
      <hr />
    </div>
  </div>
  
</div>
</div>
<div class="modal-footer">
  <div
    class="d-flex flex-row justify-content-between w-100"
   
   
  >
  <button class="btn btn-primary" *ngIf="cartItems?.length > 0" style="border-radius: 0 !important;" (click)="OnCheckout()">Checkout</button>
  
  <button class="btn btn-danger" style="border-radius: 0 !important;" (click)="modalReference.close()">Close</button>
    
   
  </div>
</div>
  
</ng-template>

<ng-template #scanPopup>
  <div class="modal-header">
    <h5 class="modal-title f-w-600" id="exampleModalLabel">Scan</h5>
    <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="OnClose()"
        >
            <span aria-hidden="true">&times;</span>
        </button>
  </div>
  <div class="modal-body" >
      <div class="scanner-container absolute inset-0 flex flex-col min-w-0 overflow-hidden">
       
      <qr-scanner #qrscanner (capturedQr)="capturedQr($event)"  
      [texts]="{
          NotSupportedHTML: 'You are using an outdated browser',
          DeviceDefaultPrefix: 'Camera',
          StopCameraText: 'Stop Camera',
          OpenButtonText: 'Open QR Code File...'}" 
          [buttonClass]="ngClassForButtons" [allowUpload]="true" [disableScan]="false" (error)="onError($event)"  >
        
        </qr-scanner>
        
      
        <div *ngIf="isContainerVisible" class="rectangle-overlay" > 
          <div class="line" [style.top.%]="linePosition"></div>
          </div>
        </div>
      </div>
      
  
      
</ng-template>
<ng-template #OrderSuccess>
  <div class="modal-header">
    <h5 class="modal-title f-w-600" id="exampleModalLabel">Order Details</h5>
    <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="OnClose()"
        >
            <span aria-hidden="true">&times;</span>
        </button>
  </div>
  <div class="modal-body">
    <mat-progress-bar mode="determinate" [value]="progressValue"></mat-progress-bar>

    <div class="container d-flex" style="gap: 1rem;">
            
      <div class="column">
        <div class="heading font-weight-bold">Order Id:</div>
        <div class="heading font-weight-bold">Order Date:</div>
        <div class="heading font-weight-bold">Amount:</div>
        <div class="heading font-weight-bold">Payment:</div>
        <div class="heading font-weight-bold">Mode of Payment:</div>
       
        <!-- <div class="heading">Delivery Address:</div> -->
        <!-- Add more headings as needed -->
      </div>
      <div class="column">
        <div class="value">{{ orderDetails?.orderId }}</div>
        <div class="value">{{ orderDetails?.orderDateTime | date: 'yyyy-MM-dd HH:mm:ss'}}</div>
        <div class="value">{{ orderDetails?.amount }}</div>
        <div class="value">{{ orderDetails?.paymentStatus }}</div>
        <div class="value">{{ orderDetails?.paymentMode}}</div>
      
        <!-- <div class="value">{{ orderDetails?.shippingAddressName }}</div> -->
        <!-- Add more values as needed -->
      </div>
    </div>
    <div class=" mt-3 ml-3 mb-3">
      <div class="row font-bold mb-1">
        <!-- Headings -->
        <div class="col"><strong >Item ID/Name</strong></div>
        <div class="col text-center"><strong> Qty </strong></div>
        <div class="col"><strong> Price</strong></div>
      </div>
      <div *ngFor="let orderitems of orderDetails.orderItems" class="row clearfix mb-2">
        <!-- Values -->
        <div class="col">{{ orderitems?.itemName }}-{{
          orderitems?.uom}}</div>
        <div class="col text-center"> {{ orderitems.quantity }}</div>
        <div class="col">{{ orderitems.totalPrice }}</div>
      </div>
    </div>
    <div class="dispense-btns d-flex ">
      <button class="btn btn-primary" (click)="OnDispense()">Dispense</button>
    </div>
  </div>
</ng-template>
<!--footer section end -->
